import {
  AfterViewInit,
  ChangeDetectionStrategy,
  ChangeDetectorRef,
  Component,
  ElementRef,
  Inject,
  Input,
  OnDestroy,
  OnInit,
  PLATFORM_ID, ViewChild,
  ViewEncapsulation
} from '@angular/core';
import { fadeInAnimation } from '../../../../../../shared/animations/fade-in.animation';
import { BehaviorSubject, Subscription } from 'rxjs';
import { ProfessionalStyle, ProfessionalStyleService } from '@adeo/ngx-kozikaza-api';
import { ProfessionalServiceType } from '@adeo/ngx-kozikaza-api/pro/service';
import { ActivatedRoute, Router } from '@angular/router';
import { LocalizeRouterService } from '@gilsdav/ngx-translate-router';
import { debounceTime, filter, map, take, tap } from 'rxjs/operators';
import { RoutesService } from '../../../../../../shared/services/routes/routes.service';
import { MediaQueriesService } from '../../../../../../shared/services/utilities/media-queries.service';
import { boxSlug, decoOffersSlug } from '../../../professional-routing.module';
import PlaceResult = google.maps.places.PlaceResult;
import { isPlatformBrowser } from '@angular/common';
import { KzIconsRegistryService } from '../../../../../../kz-ui/ui/icon/kz-icons-registry.service';
import { kzIconsCrosshair } from '../../../../../../kz-ui/ui/icon/generated-icons/kzIcons-crosshair.icon';
import { kzIconsArrowrightFull } from '../../../../../../kz-ui/ui/icon/generated-icons/kzIcons-arrowright-full.icon';
import { kzIconsCompass } from '../../../../../../kz-ui/ui/icon/generated-icons/kzIcons-compass.icon';
import { kzIconsMenu } from '../../../../../../kz-ui/ui/icon/generated-icons/kzIcons-menu.icon';
import { kzIconsCoaching } from '../../../../../../kz-ui/ui/icon/generated-icons/kzIcons-coaching.icon';
import { kzIconsSort } from '../../../../../../kz-ui/ui/icon/generated-icons/kzIcons-sort.icon';
import { kzIconsSortAsc } from '../../../../../../kz-ui/ui/icon/generated-icons/kzIcons-sort-asc.icon';
import { kzIconsSortDesc } from '../../../../../../kz-ui/ui/icon/generated-icons/kzIcons-sort-desc.icon';
import { UserStoreService } from '../../../../../../shared/services/state-management/user-store.service';
import { kzIconsLike } from '../../../../../../kz-ui/ui/icon/generated-icons/kzIcons-like.icon';
import { kzIconsSearch } from '../../../../../../kz-ui/ui/icon/generated-icons/kzIcons-search.icon';
import { kzIconsLaptop } from 'src/app/kz-ui/ui/icon/generated-icons/kzIcons-laptop.icon';
import { kzIconsFilter, kzIconsGift, kzIconsHome } from 'src/app/kz-ui/ui/icon/kz-icons';
import { TranslateService } from '@ngx-translate/core';
import { GoogleMapsUtilsService } from '../../../../../../shared/google-maps-utils/google-maps-utils.service';
import { cities } from '../../pro-listing-city';

@Component({
  selector: 'app-pro-listing-search',
  templateUrl: './pro-listing-search.component.html',
  styleUrls: ['./pro-listing-search.component.scss'],
  changeDetection: ChangeDetectionStrategy.OnPush,
  encapsulation: ViewEncapsulation.None,
  animations: [ fadeInAnimation ]
})
export class ProListingSearchComponent implements OnInit, OnDestroy, AfterViewInit {
  @Input() bannerType: 'pro' | 'pro-box' = 'pro';
  @ViewChild('inputGeoloc') inputGeoloc: ElementRef;

  loading = false;
  private _searchBrand: BehaviorSubject<boolean> = new BehaviorSubject(false);
  brand: string;

  items: Array<ProfessionalStyle | ProfessionalServiceType> = [];
  itemSelected: ProfessionalStyle | ProfessionalServiceType;

  brandSubscription: Subscription;
  activatedRouteSubscription: Subscription;

  geo = null;
  geoTmp = null;
  error = false;
  atHome = null;
  city = null;
  coachDistance = false;

  boxFiltered = false;
  displayServices = false;
  showFavorites = false;

  currentSort: 'ASC' | 'DESC';

  boxPath: Array<string> = [];
  servicesPath: Array<string> = [];
  reverseBoxPath: Array<string> = [];
  jobPath: Array<string> = [];
  cityPath: Array<string> = [];

  filteredPath: Array<string> = [];
  isBrowser = false;

  citiesKeyList = Object.keys(cities);
  citiesList = cities;

  constructor(
    @Inject(PLATFORM_ID) public platformId: string,
    private professionalStyleService: ProfessionalStyleService,
    public activatedRoute: ActivatedRoute,
    private localizeRouterService: LocalizeRouterService,
    private router: Router,
    private routesService: RoutesService,
    public mediaQueriesService: MediaQueriesService,
    public cdr: ChangeDetectorRef,
    private kzIconsRegistryService: KzIconsRegistryService,
    public userStoreService: UserStoreService,
    private readonly translateService: TranslateService,
    public googleMapsUtilsService: GoogleMapsUtilsService,
  ) {
    this.kzIconsRegistryService.registerIcons([kzIconsCrosshair, kzIconsArrowrightFull, kzIconsCompass,
      kzIconsMenu, kzIconsCoaching, kzIconsSort, kzIconsSortAsc, kzIconsSortDesc, kzIconsLike, kzIconsSearch, kzIconsLaptop, kzIconsHome, kzIconsGift, kzIconsFilter]);
    this.isBrowser = isPlatformBrowser(platformId);
  }

  ngOnInit(): void {
    this.getParams();

    this.brandSubscription = this._searchBrand.pipe(
      filter((val) => val === true),
      filter(() => this.brand.length > 3),
      tap((val) => {
        this.loading = true;
        this.cdr.detectChanges();
      }),
      debounceTime(1000),
      tap((text) => {
        this.search();
      })
    ).subscribe();
  }

  ngAfterViewInit() {
    if (this.geoTmp && isPlatformBrowser(this.platformId)) {
      this.inputGeoloc.nativeElement.value = this.geoTmp;
    }
  }

  searchBrand(): void {
    this._searchBrand.next(true);
  }

  toggleFavorites():void {
    this.resetAll();
    this.search();
  }

  toggleBoxable():void {
    this.router.navigate(this.localizeRouterService.translateRoute([].concat(['/pro'], this.servicesPath, this.reverseBoxPath, this.filteredPath)) as string[], {queryParams: {page: null}, queryParamsHandling: 'merge'});
  }

  resetAll(): void {
    this.itemSelected = null;
    this.currentSort = null;
    this.geo = null;
    this.geoTmp = null;
    this.inputGeoloc.nativeElement.value = this.geoTmp;
    this.city= null;

    this.brand = null;
  }

  resetSearch(e): void {
    this.itemSelected = null;
    this.search();
  }

  resetSort(e): void {
    this.currentSort = null;
    this.search();
  }

  resetGeo(e): void {
    e.stopPropagation();
    this.geo = null;
    this.geoTmp = null;
    this.inputGeoloc.nativeElement.value = '';
    this.atHome = null;
    this.city= null;
    this.cityPath = [];
    this.coachDistance = null;
    this.cdr.detectChanges();
    this.search();
  }

  toggleLocationFilter(e): void {
    if (!this.atHome) {
      this.resetGeo(e);
    }
    this.resetAll();
    this.search();
  }

  getParams(): void {
    this.activatedRouteSubscription = this.routesService.eventNavigationEnd.pipe(
      map(() => this.activatedRoute.snapshot),
      tap((route: any) => {
        this.boxFiltered = !!route.data.isBox;
        this.displayServices = !!route.data.isDecoOffers;
        this.itemSelected = this.displayServices
          ? route.parent?.parent?.data?.serviceType
          : route.parent?.parent?.data?.style;
        this.items = this.displayServices
          ? (route.data?.serviceTypes || [])
          : (route.data?.styles || []);
        this.filteredPath = !!this.itemSelected
          ? [`${this.displayServices ? 'type-' : 'style-'}` + this.itemSelected.nameSlug]
          : []

        this.geo = ((route.queryParams && route.queryParams.geo) ? route.queryParams.geo: null);
        this.atHome = ((route.queryParams && route.queryParams.atHome) ? route.queryParams.atHome: null);
        this.coachDistance = ((route.queryParams && route.queryParams.coachDistance) ? route.queryParams.coachDistance: null);
        this.currentSort = ((route.queryParams && route.queryParams.sort) ? route.queryParams.sort: null);
        this.geoTmp = ((this.geo && this.geo !== '') ? decodeURI(this.geo.split('_')[0]) : null);
        this.showFavorites = ((route.queryParams && route.queryParams.favorites) ? true: false);
        this.brand = ((route.queryParams && route.queryParams.brand) ? decodeURI(route.queryParams.brand): null);
        this.city = ((route.params && route.params.citySlug) ? route.params.citySlug: null);


        const urlTree = this.router.parseUrl(this.router.url);
        const urlSegments = urlTree.root.children.primary.segments;
        urlSegments.map(it => it.path).filter((seg) => {
          if (seg == this.translateService.instant('routes.interior-decorator')) {
            this.jobPath = ['interior-decorator'];
            return true;
          }
          if (seg == this.translateService.instant('routes.interior-architect')) {
            this.jobPath = ['interior-architect'];
            return true;
          }
          return false;
        });
        this.boxPath = this.boxFiltered ? [boxSlug] : [];
        this.servicesPath = this.displayServices ? [decoOffersSlug] : [];
        this.reverseBoxPath = !this.boxFiltered ? [boxSlug] : [];

        if (this.city) {
          this.geoTmp = (route.params.cityGeo) ? decodeURI(route.params.cityGeo.split('_')[0]) : null;
          this.geo = (route.params.cityGeo) ? route.params.cityGeo: null;
          this.cityPath = [this.city];
        } else {
          this.cityPath = [];
        }
      })
    ).subscribe();
  }

  trackById(index, data): number {
    return data ? data['@id'] : undefined;
  }


  onAddressSelected(result: PlaceResult) {
    this.error = false;
    const position = result.geometry.location;
    this.geoTmp = result.formatted_address;
    this.atHome = true;
    this.coachDistance = null;
    this.geo = encodeURI(result.formatted_address) + '_' + position.lat().toString() + '_' + position.lng().toString();
    this.cityPath = Object.keys(cities).filter((key) => (cities[key].geoloc === this.geo));
    this.city = (this.cityPath[0]) ? this.cityPath[0]: null;
    this.cdr.detectChanges();

    this.search();
  }


  search(): void {
    const route = (this.itemSelected) ?
      ['/', 'pro', ...this.jobPath, ...this.cityPath, ...this.servicesPath, ...this.boxPath, `${this.displayServices ? 'type-' : 'style-'}` + this.itemSelected.nameSlug]:
      ['/', 'pro', ...this.jobPath, ...this.cityPath, ...this.servicesPath,  ...this.boxPath];
    const params = {
      page: null,
      geo: (this.geo && !this.city) ? this.geo : null,
      atHome: (this.atHome) ? this.atHome : null,
      coachDistance: (this.coachDistance) ? this.coachDistance : null,
      sort: this.currentSort || null,
      favorites: this.showFavorites || null,
      brand: this.brand || null
    }

    this.loading = false;
    this.cdr.detectChanges();

    this.router.navigate(this.localizeRouterService.translateRoute(route) as string[], {
      queryParams: params,
      queryParamsHandling: "merge"
    });
  }

  selectAllContent($event) {
    $event.target.select();
  }

  geolocateMe() {
    this.googleMapsUtilsService.geolocateMe().pipe(
      take(1),
      tap((result) => {
        this.onAddressSelected(result);
      })
    ).subscribe();
  }

  ngOnDestroy(): void {
    if (this.activatedRouteSubscription && !this.activatedRouteSubscription.closed) {
      this.activatedRouteSubscription.unsubscribe();
    }

    if (this.brandSubscription && !this.brandSubscription.closed) {
      this.brandSubscription.unsubscribe();
    }
  }
}
